export default __webpack_public_path__ + "static/media/MaddoxBlake.41519105.svg";